import { defineMessages } from 'react-intl';

const ID_PREFIX = 'EctlRecord.';
export const messages = defineMessages({
  supportExpirationDate: {
    id: `${ID_PREFIX}supportExpirationDate`,
    defaultMessage: 'Support expires on {theDate}'
  },
  installTypeServer: {
    id: `${ID_PREFIX}installTypeServer`,
    defaultMessage: 'Server'
  },
  installTypeDc: {
    id: `${ID_PREFIX}installTypeDc`,
    defaultMessage: 'Data Center'
  },
  numberOfSeatsUnitUsers: {
    id: `${ID_PREFIX}numberOfSeatsUnitUsers`,
    defaultMessage: 'users'
  },
  numberOfSeatsUnitAgents: {
    id: `${ID_PREFIX}numberOfSeatsUnitAgents`,
    defaultMessage: 'agents'
  },
  ectlWillLastUntil: {
    id: `${ID_PREFIX}ectlWillLastUntil`,
    defaultMessage: 'CLOUD MIGRATION TRIAL WILL LAST UNTIL {theDate}'
  },
  ectlExpiresInTwoMonths: {
    id: `${ID_PREFIX}ectlExpiresInTwoMonths`,
    defaultMessage: 'CLOUD MIGRATION TRIAL WILL LAST 2 MONTHS FROM TODAY'
  },
  claimedEctlExpiresOn: {
    id: `${ID_PREFIX}claimedEctlExpiresOn`,
    defaultMessage: 'CLOUD MIGRATION TRIAL EXPIRES ON {theDate}'
  },
  purchaseTypeCommercialLic: {
    id: `${ID_PREFIX}purchaseTypeCommercialLic`,
    defaultMessage: 'Commercial License'
  },
  purchaseTypeAcademicLic: {
    id: `${ID_PREFIX}purchaseTypeAcademicLic`,
    defaultMessage: 'Academic License'
  },
  purchaseTypeCommercialSub: {
    id: `${ID_PREFIX}purchaseTypeCommercialSub`,
    defaultMessage: 'Commercial Subscription'
  },
  purchaseTypeAcademicSub: {
    id: `${ID_PREFIX}purchaseTypeAcademicSub`,
    defaultMessage: 'Academic Subscription'
  },
  ctaButtonText: {
    id: `${ID_PREFIX}ctaButtonText`,
    defaultMessage: 'Activate trial'
  }
});
